import { LexicalNodeReplacement, ParagraphNode, TextNode, type Klass, type LexicalNode } from 'lexical';

import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { MarkNode } from '@lexical/mark';
import { OverflowNode } from '@lexical/overflow';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';

import { ExcalidrawNode } from './_lexical/ExcalidrawNode';
import { PhxTextEntityNode } from './PhxTextEntityNode';
import { PhxParagraphNode } from './PhxParagraphNode';
import { PhxListNode } from './PhxListNode/PhxListNode';
import { PhxListItemNode } from './PhxListNode/PhxListItemNode';
import { PhxTextNode } from './PhxTextNode';
import { PhxDeleteNode } from './PhxDeleteNode';
import { PhxInsertNode } from './PhxInsertNode';
import { InlineImageNode } from './InlineImageNode/InlineImageNode';
import { ImageNode } from './ImageNode';
import { PhxCrossReferenceLinkNode } from './PhxCrossReferenceLinkNode';

const PhoenixNodes: Array<Klass<LexicalNode> | LexicalNodeReplacement> = [
  ExcalidrawNode,
  HeadingNode,
  QuoteNode,
  CodeNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  HashtagNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  HorizontalRuleNode,
  MarkNode,
  PhxTextEntityNode,
  PhxDeleteNode,
  PhxInsertNode,
  PhxParagraphNode,
  {
    replace: ParagraphNode,
    with: (node: ParagraphNode) => {
      return new PhxParagraphNode();
    }
  },
  LinkNode,
  PhxListNode,
  PhxListItemNode,
  PhxTextNode,
  {
    replace: TextNode,
    with: (node: TextNode) => {
      const parent = node.getParent();
      if (parent instanceof PhxCrossReferenceLinkNode) {
        return node;
      }
      return new PhxTextNode(node.__text);
    },
  },
  ImageNode,
  InlineImageNode,
  PhxCrossReferenceLinkNode,
];

export default PhoenixNodes;
